<style lang="less">
.wzLoading {
  &__msg {
    font-size:.28rem;
    text-align: center;
    padding:2rem 0;
  }
}
</style>
<template>
  <div :class="`wzPage wzPage--${name}`">
    <div v-if="$slots.head" :class="`wzHead wzHead--${name}`">
      <slot name="head"></slot>
    </div>
    <div :class="`wzBody wzBody--${name}`">
      <div class="wzLoading" v-if="isLoading">
        <slot name="loading">
          <div class="wzLoading__msg">数据加载中…</div>
        </slot>
      </div>
      <slot v-else> </slot>
    </div>
    <div v-if="$slots.foot" :class="`wzFoot wzFoot--${name}`">
      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wz-page',
  props: ['name', 'isLoading']
}
</script>
